(function () {
	'use strict';

	angular.module('app.dashboard')
		.controller('leanProjectProgressSummaryCtrl', leanProjectProgressSummaryCtrl);

	function leanProjectProgressSummaryCtrl($rootScope, $scope, $timeout, leanFilterService,
			dashboardFilterInitializationService, leanProjectProgressSummaryService, pageTimingService) {
		$scope.chartData = [];
		$scope.filterService = dashboardFilterInitializationService;
		$scope.leanFilterService = leanFilterService;
		$scope.$parent.$parent.showViewReport = true;
		if (!$scope.$parent.content.defaultDrillDownUrl) {
			$scope.$parent.content.defaultDrillDownUrl = $scope.$parent.content.drillDownUrl;
		}
		$scope.slideshowView = $rootScope.slideshowView;

		updateEventBind($scope, ['sideBarUpdate', 'adfFactoryChanged',
			'slideshowViewChanged', 'leanProjectFilterChanged']);

		function getChart() {
			var columnDefinition = $scope.$parent.$parent.col;
			var curWidget = $scope.$parent.model;
			leanProjectProgressSummaryService.getLeanProjectProgressSummary($scope.leanFilterService)
				.then(
					function (d) {
						$scope.chartData = d.chartData;
						$scope.categories = [
							'Late ' + d.reviewInterval + '+ Days',
							'Due Last ' + d.reviewInterval + ' Days',
							'Due Next ' + d.reviewInterval + ' Days'
						];
						$scope.$broadcast('event:leanProjectProgressSummaryCtrl:getChart', null);
						if (!$scope.slideshowView) {
							pageTimingService.markWidgetDoneLoading('column' + columnDefinition.columnIndex, columnDefinition.widgets.indexOf(curWidget));
						}
					},
					function (e) {
						$scope.$broadcast('event:leanProjectProgressSummaryCtrl:getChart', null);
						if (!$scope.slideshowView) {
							pageTimingService.markWidgetDoneLoading('column' + columnDefinition.columnIndex, columnDefinition.widgets.indexOf(curWidget));
						}
					}
				);
		}

		var loadData = function () {
			if (!dashboardFilterInitializationService.updating['initialLoad']) {
				var columnDefinition = $scope.$parent.$parent.col;
				var curWidget = $scope.$parent.model;
				if (!$scope.slideshowView) {
					dashboardFilterInitializationService.markWidgetCreated('column' + columnDefinition.columnIndex, columnDefinition.widgets.indexOf(curWidget));
				}
				getChart();
			} else {
				$timeout(loadData, 100);
			}
		};

		loadData();
	}
})();
